"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _dateUtils = require("../dateUtils");

var _Icons = require("./Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Hours = /*#__PURE__*/function (_React$Component) {
  _inherits(Hours, _React$Component);

  var _super = _createSuper(Hours);

  function Hours(props) {
    var _this;

    _classCallCheck(this, Hours);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "start", function (e, step) {
      e.preventDefault();

      if (_this.interval) {
        clearInterval(_this.interval);
      }

      _this.fireChange(_this.props.hour + step);

      _this.interval = setInterval(function () {
        _this.fireChange(_this.props.hour + step);
      }, 200);
    });

    _defineProperty(_assertThisInitialized(_this), "stop", function (e) {
      e.preventDefault();

      if (_this.interval) {
        clearInterval(_this.interval);
        _this.interval = undefined;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fireChange", function (newHour) {
      if (newHour > 23) newHour = 0;
      if (newHour < 0) newHour = 23;

      _this.props.changeEvent(newHour);
    });

    _this.state = {};
    return _this;
  }

  _createClass(Hours, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var hour = this.props.hour;
      var hourString = hour.toString();
      hourString = (0, _dateUtils.mapToFarsi)('00'.substring(0, 2 - hourString.length) + hourString);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-HourMinute"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Nav JC-Nav-Hour",
        onMouseDown: function onMouseDown(e) {
          return _this2.start(e, 1);
        },
        onMouseUp: function onMouseUp(e) {
          return _this2.stop(e);
        },
        onTouchStart: function onTouchStart(e) {
          return _this2.start(e, 1);
        },
        onTouchEnd: function onTouchEnd(e) {
          return _this2.stop(e);
        }
      }, /*#__PURE__*/_react.default.createElement(_Icons.UpIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
        className: "JC-Title",
        style: {
          textAlign: 'right'
        }
      }, hourString), /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Nav JC-Nav-Hour",
        onMouseDown: function onMouseDown(e) {
          return _this2.start(e, -1);
        },
        onMouseUp: function onMouseUp(e) {
          return _this2.stop(e);
        },
        onTouchStart: function onTouchStart(e) {
          return _this2.start(e, -1);
        },
        onTouchEnd: function onTouchEnd(e) {
          return _this2.stop(e);
        }
      }, /*#__PURE__*/_react.default.createElement(_Icons.DownIcon, null)));
    }
  }]);

  return Hours;
}(_react.default.Component);

var _default = Hours;
exports.default = _default;